export default {
    workspaceAccountsForSniffdeckSelect(state) {
        const workspaceAccounts = [];

        for (const account of state.workspaceAccounts) {
            workspaceAccounts.push({
                id: account.feedername,
                text: `${account.sourcename} - ${account.feedername}`
            });
        }

        return workspaceAccounts;
    },
    workspaceAgentsForSelect(state) {
        const workspaceAgents = [];
        
        for (const agent of state.workspaceAgents) {
            workspaceAgents.push({
                id: agent.ntusername,
                text: agent.name
            });
        }
        
        return workspaceAgents;
    },
    workspaceAgentsForReportSelect(state) {
        const workspaceAgents = [];
        
        for (const agent of state.workspaceAgents) {
            workspaceAgents.push({
                id: agent.id,
                text: agent.name
            });
        }
        
        return workspaceAgents;
    },
    workspaceAgents(state) {
        return state.workspaceAgents;
    },
    workspaceQueuesForSelect(state) {
        const workspaceQueues = [];
        
        for (const queue of state.workspaceQueues) {
            workspaceQueues.push({
                id: `${queue.id}`,
                text: queue.queueName
            });
        }

        return workspaceQueues;
    },
    workspaceIsPrivateSend(state) {
        const isPrivateSend = state.workspaceIsPrivateSend ;
        return isPrivateSend;
    }
}